module.exports = __webpack_public_path__ + "media/images/markers/pin-024b21b4585eea18f33748ae40ef2162.png";